import {Option} from 'react-select/src/filters';

/**
 * Given an ETL fill map and a data object, return a new object with properties of Field names and
 * values of Field values suitable for injecting into Form state
 *
 * @param fillMap ETL fill map
 * @param data data object to be mapped to Form state
 */
export const applyFillMap = (fillMap: any, data: any): object => {
    return Object.keys(fillMap).reduce((acc: any, sourceProperty: string) => {
        // mapping contains properties from ETL response and value is either the ID of the target field, or an
        // array of IDs to target fields in the case that a single response value maps to multiple form fields
        const targetFieldIds: string[] = (fillMap[sourceProperty] instanceof Array) ?
            fillMap[sourceProperty]
            :
            [fillMap[sourceProperty]];

        // take the array of target fields IDs and create an object with properties of field names
        // and values of field values
        const opts: any = targetFieldIds.reduce((acc1: any, targetField: object | string) => {
            let targetFieldId = targetField;
            let targetFieldOptions: any = {
                decodeJson: false,
                makeSelectOption: false
            };

            if (
                typeof targetField === 'object' &&
                targetField !== null &&
                targetField.hasOwnProperty('fieldId')
            ) {
                targetFieldId = targetField.fieldId;
                targetFieldOptions = {
                    ...targetFieldOptions,
                    ...targetField
                };
            }

            // not sure i should be doing the translation here.....
            const targetFieldName = 'input_' + targetFieldId;

            let dataValue: any = '';
            if (sourceProperty.match(/\.\d+$/)) {
                const arr: any[] = sourceProperty.split('.', 2);
                const realSourceProperty: string = arr[0];
                const sourcePropertyIndex: number = arr[1];

                dataValue = (
                    data.hasOwnProperty(realSourceProperty) &&
                    data[realSourceProperty] instanceof Array &&
                    data[realSourceProperty].length - 1 >= sourcePropertyIndex
                ) ?
                    data[realSourceProperty][sourcePropertyIndex]
                    :
                    '';
            } else {
                dataValue = data?.hasOwnProperty(sourceProperty) ? data[sourceProperty] : '';
                if (targetFieldOptions.decodeJson) {
                    try {
                        dataValue = JSON.parse(dataValue);
                    } catch (e) {
                        console.log(e);
                    }
                } else if (targetFieldOptions?.makeSelectOption) {
                    dataValue = {text: dataValue, label: dataValue, value: dataValue};
                }
            }

            return {
                ...acc1,
                [targetFieldName]: dataValue
            };
        }, {});

        return {
            ...acc,
            ...opts
        };

    }, {})
};